import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=71ff8ada&scoped=true&"
import script from "./MagicLink.vue?vue&type=script&lang=js&"
export * from "./MagicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff8ada",
  null
  
)

export default component.exports